// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__16xeO","buttons":"SendReceipts_buttons__2vX0X","email":"SendReceipts_email__1F-y6","bookApptTitle":"SendReceipts_bookApptTitle__3nvAx"};